export default __webpack_public_path__ + "static/media/Vhdl.3cb9bfd6.png";